<script lang="ts">
  import {
    bannerShown,
    watchBanner,
    type BannerVisibility,
  } from 'shared/javascripts/video_banners/visibility'
  import type { SubstituteLogoData } from './types'

  let {
    logo,
    container,
    element = $bindable(),
  }: {
    logo: SubstituteLogoData
    /** The player container, which the player emits its `app:player:*` events on. */
    container?: HTMLElement
    element?: HTMLElement
  } = $props()

  let visibility = $state<BannerVisibility>({
    inTimeWindow: false,
    adRunning: false,
    closed: false,
  })

  $effect(() => {
    if (!container) {
      return
    }

    const watched = watchBanner(container, logo, (next) => {
      visibility = next
    })

    return () => watched.destroy()
  })

  const classes = $derived(
    ['substitute-logo', bannerShown(visibility) && '-visible'].filter(Boolean).join(' '),
  )
</script>

<!-- eslint-disable-next-line svelte/no-at-html-tags -- server-built fragment -->
<div class={classes} bind:this={element}>{@html logo.content_html}</div>
